import angular from 'angular';
import { leftOrMiddleClickDirective } from './leftOrMiddleClickDirective';

angular.module('sh.leftOrMiddleClick', []).directive('shLeftOrMiddleClick', leftOrMiddleClickDirective);
